import { styled } from 'styled-components';
import { CSSProperties, useEffect, useMemo } from 'react';
import { LoginState, useAuth } from '../../hook/useAuth';
import TopBar from '../../components/layout/TopBar';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import ErrorBoundary from '../../components/layout/ErrorBoundary';
import styleConstants from '../../constants/styleConstants';
import useLittleScreen from '../../hook/useLittleScreen';
import TopBarMobile from '../../components/layout/TopBarMobile';
import ChevronDown from '../../components/icons/ChevronDown';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchAlbum } from '../../hook/useFetchOrCreateAlbum';
import { Album } from '../../types/models/Album';
import { CardFromServer } from '../../types/models/Cards';
import { Calendar } from '../../types/models/Calendar';
import { Other } from '../../types/models/Other';
import { fetchDispatchCalendar } from '../../hook/useFetchOrCreateCalendar';
import { fetchDispatchCard } from '../../hook/useFetchOrCreateCard';
import { fetchDispatchOther } from '../../hook/useFecthOrCreateOther';
import { albumFormats } from '../../constants/albumFormats';
import { calendarFormats } from '../../constants/calendarFormats';
import { formats } from '../../constants/formats';
import { otherFormats } from '../../constants/otherFormats';
import { useSearchParams } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRef } from 'react';

// Import Swiper styles
import 'swiper/css';
import RightArrow from '../../components/icons/RightArrow';
import LeftArrow from '../../components/icons/LeftArrow';
import CookieHandler from '../home/CookieHandler';
import OptionZenSection from './OptionZenSection';
import ChecklistSection from './ChecklistSection';
import { useTranslation } from 'react-i18next';
import { isRigideFormat, getSliceWidthAndTop } from '../../utils/slicePositioning';

export const ParentElement = (props: any) => {
    const [searchParams] = useSearchParams();
    const preview = Boolean(parseInt(searchParams.get('preview') ?? '0') || 0);
    if (preview) {
        return <div>{props.children}</div>
    }

    return <>{props.children}</>
}


const UpperSlideTextElement = ({
    pageNumber,
    doublePage,
    creationType,
    noOfPages,
    isActive,
}: {
    pageNumber: number,
    doublePage: boolean,
    creationType: string,
    noOfPages: number,
    isActive: boolean,
}) => {

    const isSinglePageSpread = creationType === "album" && doublePage && (
        pageNumber === 1 || (noOfPages > 1 && pageNumber === noOfPages && noOfPages % 2 === 0)
    );
    const upperTextStyles: CSSProperties = {
        marginLeft: "1.5rem",
        marginBottom: "0.5rem",
        border: '2px solid grey',
        borderRadius: '5px',
        width: '50px',
        textAlign: 'center',
        fontSize: 12
    }

    if (creationType === "carte") {
        pageNumber+=1;
        upperTextStyles.marginLeft = "0.35rem";
    }

    let upperText = `${pageNumber}`;
    if (doublePage && !isSinglePageSpread) {
        upperText = `${pageNumber}-${pageNumber+1}`
    }

    if (pageNumber === 0 && creationType === "album") {
        upperText = "Couverture";
        upperTextStyles.marginTop = "2.5px";
        upperTextStyles.marginBottom = "0.6rem";
        upperTextStyles.width = "100px";
        upperTextStyles.marginLeft = "0rem";
    }

    if (creationType === "calendrier") {
        upperTextStyles.marginLeft = "0.25rem";
        if (pageNumber === 0) {
            upperText = "Couverture";
            upperTextStyles.marginTop = "2.5px";
            upperTextStyles.marginBottom = "0.6rem";
            upperTextStyles.width = "70px";
            upperTextStyles.marginLeft = "0rem";
        }   
    }

    if (creationType === "carte") {
        upperTextStyles.marginLeft = "0.27rem";
    }

    if (isActive) {
        const isAlbumCover = creationType === "album" && pageNumber === 0;
        upperTextStyles.backgroundColor = isAlbumCover ? "#1F1F1F" : "#2E7C81";
        upperTextStyles.color = "white";
        upperTextStyles.border = isAlbumCover ? "2px solid #1F1F1F" : "2px solid #2E7C81";
    }

    return (
        <>
            <div>
                <div style={{...upperTextStyles}}>{upperText}
                </div>
            </div>
        </>
    )
}

const PreviewPage: React.FC = () => {
  const { asklogin, userInfo, isReady, uuidInCookie } = useAuth();
  const params = useParams();
  const [creation, setCreation] = useState<Album | CardFromServer | Calendar | Other | null>(null);
  const creationType = params?.type;
  const creationId = params?.id;
  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const swiperRef = useRef<any>(null);
    const [isPageTransitionLoading, setIsPageTransitionLoading] = useState(true);
    const [loadedIframeSrcs, setLoadedIframeSrcs] = useState<Record<string, boolean>>({});
    const iframeRefs = useRef<Record<string, HTMLIFrameElement | null>>({});
    const [canSlideThumbsPrev, setCanSlideThumbsPrev] = useState(false);
    const [canSlideThumbsNext, setCanSlideThumbsNext] = useState(false);

  if (!creationType && !creationId) {
    return "Error";
  }

  useEffect(() => {
    const openLoginPage = async () => {
        console.log("userInFo", userInfo, LoginState);
        if (!userInfo) {
            await asklogin(false);
        }
      if (userInfo && userInfo.state !== LoginState.LOGGED_IN) {
        console.log('here2');
        await asklogin(true);
      }
    };
    // openLoginPage();
    const canLoadPreview = userInfo?.state === LoginState.LOGGED_IN;
    if (!isReady || userInfo === null || !canLoadPreview) return;
    if (creationType === "album") {
        fetchAlbum(creationId).then((album : Album | Response) => {
            setCreation(album as Album);
        });
    } else if (creationType === "calendrier") {
        if (creationId) {
            fetchDispatchCalendar(creationId).then((calendar: Calendar | Response) => {
                setCreation(calendar as Calendar);
            });
        }
    } else if (creationType === "carte") {
        if (creationId) {
            fetchDispatchCard(creationId).then((card: any) => {
                setCreation(card as CardFromServer);
            }).catch(e => console.error(e));
        }
    } else if (creationType === "autre") {
        if (creationId) {
            fetchDispatchOther(creationId).then((autre: any) => {
                setCreation(autre);
            })
        }
    }
  }, [userInfo, isReady, uuidInCookie]);

  let noOfPages = 0;
  let doublePage = false;
  let pagesArray: number[] = [];
  let aspectRatio = 0;
  let coverAspectRatio = 0;
  if (creation) {
    let format: any = null;
    if (creationType === "album") {
        doublePage = true;
        noOfPages = (creation as Album)?.albumPages?.length ?? 0;
        if (noOfPages === 0) {
            doublePage = false;
        }
        pagesArray = [0];
        if (noOfPages >= 1) pagesArray.push(1);
        for (let i = 2; i < noOfPages; i += 2) {
            pagesArray.push(i);
        }
        if (noOfPages >= 2 && noOfPages % 2 === 0) pagesArray.push(noOfPages);
        format = albumFormats[creation.format];

        if (format) {
            const { width, height } = format;
            aspectRatio = width / height;
            if (isRigideFormat(creation.format)) {
                const { widthMM: sliceWidthMM } = getSliceWidthAndTop(creation.format, noOfPages + 2);
                coverAspectRatio = (2 * (width + 21) + sliceWidthMM) / (height + 36);
            } else {
                coverAspectRatio = aspectRatio * 2;
            }
        }
    } else if (creationType === "calendrier") {
        noOfPages = (creation as Calendar)?.calendarMonths?.length ?? 0;
        pagesArray = Array.from(Array(noOfPages).keys());

        format = calendarFormats[creation.format];
        if (format) {
            let { width, height, types } = format;
            if (currentPageNumber > 0 && types.includes("GRID")) {
                height*=2;
            }

            if (width > height ) {
                aspectRatio = width / height;
            } else if (width < height) {
                aspectRatio = height / width;
            } else {
                aspectRatio = 1;
            }

            aspectRatio = width / height;
        }
    } else if (creationType === "carte") {
        const cardCreation = creation as any;
        noOfPages = cardCreation?.faces ?? 0;
        pagesArray = Array.from(Array(noOfPages).keys());

        const faceSizes = cardCreation?.facesSizes ?? [];
        const faceSize = faceSizes[currentPageNumber] ?? faceSizes[0];
        if (faceSize?.width && faceSize?.height) {
            aspectRatio = faceSize.width / faceSize.height;
        }
    } else if (creationType === "autre") {
        noOfPages = 1;
        pagesArray = [0];

        format = otherFormats[creation.format];

        if (format) {
            const { width, height } = format;
            aspectRatio = width / height;
        }
    }
    
  }

  const littleScreen = useLittleScreen();

  const [isMobileInfoBoxOpen, setIsMobileInfoBoxOpen] =  useState(false);
  const isCover = creationType === "album" && currentPageNumber === 0;
  const isPageOneSpread = doublePage && currentPageNumber === 1;
  const isLastPageSpread = doublePage && noOfPages > 1 && currentPageNumber === noOfPages;
  const showSecondIframe = doublePage && !isCover && !isPageOneSpread && !isLastPageSpread;
  const firstIframeJustifyStyle = (showSecondIframe || isLastPageSpread) ? "flex-end" : "center"
  const numItems = (isPageOneSpread || showSecondIframe || isLastPageSpread) ? 2 : 1;
    const firstIframeSrc = `/generation/${creationType}/${creationId}?page=${currentPageNumber}&preview=1`;
    const secondIframeSrc = `/generation/${creationType}/${creationId}?page=${currentPageNumber + 1}&preview=1`;
    const visibleIframeSrcs = useMemo(() => {
        const iframeSrcs = [firstIframeSrc];
        if (showSecondIframe) {
            iframeSrcs.push(secondIframeSrc);
        }
        return iframeSrcs;
    }, [firstIframeSrc, secondIframeSrc, showSecondIframe]);
    const prefetchIframeSrcs = useMemo(() => {
        if (!creationType || !creationId || !pagesArray.length) {
            return [];
        }

        const currentIndex = pagesArray.indexOf(currentPageNumber);
        const candidatePages: number[] = [];

        if (currentIndex > 0) {
            candidatePages.push(pagesArray[currentIndex - 1]);
        }
        if (currentIndex < pagesArray.length - 1) {
            candidatePages.push(pagesArray[currentIndex + 1]);
        }
        if (currentIndex < pagesArray.length - 2) {
            candidatePages.push(pagesArray[currentIndex + 2]);
        }

        const visibleSrcSet = new Set(visibleIframeSrcs);

        return Array.from(new Set(candidatePages))
            .map((page) => `/generation/${creationType}/${creationId}?page=${page}&preview=1`)
            .filter((src) => !visibleSrcSet.has(src));
    }, [creationType, creationId, pagesArray, currentPageNumber, visibleIframeSrcs]);

    const spaceBetween = 8;
    const slideWidth = creationType === "album" ? 84 : 64;
  const swiperStyles: CSSProperties = {
    maxWidth: `${pagesArray.length * (slideWidth + spaceBetween)}px`,
  };

  const { t } = useTranslation('checkList');
  const guideHeaderText = t('header');

  const currentPageIndex = pagesArray.indexOf(currentPageNumber);
    const canGoPrevPage = currentPageIndex > 0;
    const canGoNextPage = currentPageIndex < pagesArray.length - 1;

    const updateThumbNavigationVisibility = (swiperInstance: any) => {
        if (!swiperInstance) {
            setCanSlideThumbsPrev(false);
            setCanSlideThumbsNext(false);
            return;
        }

        const isLocked = Boolean(swiperInstance.isLocked || pagesArray.length <= 1);
        setCanSlideThumbsPrev(!isLocked && !swiperInstance.isBeginning);
        setCanSlideThumbsNext(!isLocked && !swiperInstance.isEnd);
    };

  const goToPrevPage = () => {
        if (isPageTransitionLoading) return;
    if (currentPageIndex > 0) setCurrentPageNumber(pagesArray[currentPageIndex - 1]);
  };
  const goToNextPage = () => {
        if (isPageTransitionLoading) return;
    if (currentPageIndex < pagesArray.length - 1) setCurrentPageNumber(pagesArray[currentPageIndex + 1]);
  };

    const waitForIframeStability = async (src: string) => {
        const iframe = iframeRefs.current[src];
        if (!iframe) {
            setLoadedIframeSrcs((prev) => ({ ...prev, [src]: true }));
            return;
        }

        try {
            const iframeWindow = iframe.contentWindow;
            const iframeDocument = iframe.contentDocument;
            const fontsReady = (iframeDocument as any)?.fonts?.ready;
            if (fontsReady) {
                await fontsReady;
            }
            if (iframeWindow) {
                await new Promise<void>((resolve) => {
                    iframeWindow.requestAnimationFrame(() => {
                        iframeWindow.requestAnimationFrame(() => resolve());
                    });
                });
            }
        } catch (error) {
            // Ignore iframe internals errors and fallback to marking it as ready.
        }

        setLoadedIframeSrcs((prev) => ({ ...prev, [src]: true }));
    };

    useEffect(() => {
        setIsPageTransitionLoading(true);
    }, [currentPageNumber, showSecondIframe, creationType, creationId]);

    useEffect(() => {
        if (!visibleIframeSrcs.length) return;

        const areAllIframesReady = visibleIframeSrcs.every((src) => loadedIframeSrcs[src]);
        if (!areAllIframesReady) return;

        let doneTimeout: number | undefined;
        let raf2: number | undefined;
        const raf1 = window.requestAnimationFrame(() => {
            raf2 = window.requestAnimationFrame(() => {
                doneTimeout = window.setTimeout(() => {
                    setIsPageTransitionLoading(false);
                }, 420);
            });
        });

        return () => {
            window.cancelAnimationFrame(raf1);
            if (raf2 !== undefined) {
                window.cancelAnimationFrame(raf2);
            }
            if (doneTimeout !== undefined) {
                window.clearTimeout(doneTimeout);
            }
        };
    }, [loadedIframeSrcs, visibleIframeSrcs]);

    useEffect(() => {
        const swiperInstance = swiperRef.current as any;
        if (!swiperInstance) return;
        swiperInstance.update();
        updateThumbNavigationVisibility(swiperInstance);
    }, [pagesArray.length, currentPageNumber]);

  return (
    <Container>
      <ErrorBoundary>
        {littleScreen ? <TopBarMobile isPreview /> : <TopBar isPreview />}
        <DndProvider backend={HTML5Backend}>
          <MainContainerRow>
            <MainContainerCol>
              <MainContainerCenter>
                <PreviewContainer>
                    <TestBox
                        style={{
                            color: "black",
                            flex: 1,
                            minWidth: 0,
                            width: '100%',
                        }}
                    >
                        <RendererWrapper>
                            <PageNavButton
                                side="left"
                                onClick={goToPrevPage}
                                $visible={canGoPrevPage}
                            >
                                <LeftArrow />
                            </PageNavButton>
                            <RendererContainer>
                                <RendererLoadingOverlay $visible={isPageTransitionLoading}>
                                    <LoaderDot />
                                </RendererLoadingOverlay>
                                <ZoomableContent $loading={isPageTransitionLoading}>
                                {isPageOneSpread && (
                                    <IframeContainer aspectRatio={aspectRatio}>
                                        <BlankPage aspectRatio={aspectRatio} $numItems={numItems} />
                                    </IframeContainer>
                                )}
                                <IframeContainer
                                    aspectRatio={isCover ? coverAspectRatio : aspectRatio}
                                    style={{
                                        justifyContent: firstIframeJustifyStyle,
                                    }}
                                >
                                    <RendererIframe
                                        key={firstIframeSrc}
                                        ref={(node) => {
                                            iframeRefs.current[firstIframeSrc] = node;
                                        }}
                                        aspectRatio={isCover ? coverAspectRatio : aspectRatio}
                                        $numItems={numItems}
                                        src={firstIframeSrc}
                                        onLoad={() => {
                                            void waitForIframeStability(firstIframeSrc);
                                        }}
                                        onError={() => {
                                            setLoadedIframeSrcs((prev) => ({ ...prev, [firstIframeSrc]: true }));
                                        }}
                                    >
                                    </RendererIframe>
                                </IframeContainer>

                                {
                                    showSecondIframe &&
                                    <IframeContainer
                                        aspectRatio={aspectRatio}>
                                        <RendererIframe
                                            key={secondIframeSrc}
                                            ref={(node) => {
                                                iframeRefs.current[secondIframeSrc] = node;
                                            }}
                                            aspectRatio={aspectRatio}
                                            $numItems={numItems}
                                            src={secondIframeSrc}
                                            onLoad={() => {
                                                void waitForIframeStability(secondIframeSrc);
                                            }}
                                            onError={() => {
                                                setLoadedIframeSrcs((prev) => ({ ...prev, [secondIframeSrc]: true }));
                                            }}
                                        >
                                        </RendererIframe>
                                    </IframeContainer>
                                }
                                {isLastPageSpread && (
                                    <IframeContainer aspectRatio={aspectRatio}>
                                        <BlankPage aspectRatio={aspectRatio} $numItems={numItems} />
                                    </IframeContainer>
                                )}
                                </ZoomableContent>
                                <PrefetchIframes>
                                    {prefetchIframeSrcs.map((src) => (
                                        <PrefetchIframe
                                            key={src}
                                            ref={(node: HTMLIFrameElement | null) => {
                                                iframeRefs.current[src] = node;
                                            }}
                                            src={src}
                                            onLoad={() => {
                                                void waitForIframeStability(src);
                                            }}
                                            onError={() => {
                                                setLoadedIframeSrcs((prev) => ({ ...prev, [src]: true }));
                                            }}
                                        />
                                    ))}
                                </PrefetchIframes>
                            </RendererContainer>
                            <PageNavButton
                                side="right"
                                onClick={goToNextPage}
                                $visible={canGoNextPage}
                            >
                                <RightArrow />
                            </PageNavButton>
                        </RendererWrapper>
                        <SliderContainer>
                            <ArrowButtonLeft
                                onClick={() => {
                                    if (!canSlideThumbsPrev) return;
                                    (swiperRef.current as any)?.slidePrev();
                                }}
                                $visible={canSlideThumbsPrev}
                            >
                                <LeftArrow />
                            </ArrowButtonLeft>
                            <Swiper
                                spaceBetween={spaceBetween}
                                slidesPerView="auto"
                                onSlideChange={(swiper: any) => updateThumbNavigationVisibility(swiper)}
                                onSwiper={(swiper: any) => {
                                    swiperRef.current = swiper;
                                    updateThumbNavigationVisibility(swiper);
                                }}
                                onResize={(swiper: any) => updateThumbNavigationVisibility(swiper)}
                                onReachBeginning={(swiper: any) => updateThumbNavigationVisibility(swiper)}
                                onReachEnd={(swiper: any) => updateThumbNavigationVisibility(swiper)}
                                onFromEdge={(swiper: any) => updateThumbNavigationVisibility(swiper)}
                                style={swiperStyles}
                            >
                                {
                                    pagesArray.map((page) => {
                                            const isCoverLabel = page === 0 && (creationType === "album" || creationType === "calendrier");
                                            const slideItemWidth = isCoverLabel ? 112 : (creationType === "carte" ? 56 : 76);
                                            return (
                                                <SwiperSlide
                                                    key={`${creationType}-${page}`}
                                                    onClick={() => {
                                                        if (isPageTransitionLoading) return;
                                                        setCurrentPageNumber(page)
                                                    }}
                                                    style={{
                                                        width: `${slideItemWidth}px`,
                                                        cursor: isPageTransitionLoading ? 'default' : 'pointer',
                                                    }}
                                                >
                                                    {
                                                        creationType &&
                                                        <UpperSlideTextElement
                                                            creationType={creationType}
                                                            pageNumber={page}
                                                            doublePage={doublePage}
                                                            noOfPages={noOfPages}
                                                            isActive={currentPageNumber === page}
                                                        />
                                                    }
                                                </SwiperSlide>
                                            )
                                        })
                                    }
                            </Swiper>
                            <ArrowButtonRight
                                onClick={() => {
                                    if (!canSlideThumbsNext) return;
                                    (swiperRef.current as any)?.slideNext();
                                }}
                                $visible={canSlideThumbsNext}
                            >
                                <RightArrow />
                            </ArrowButtonRight>
                        </SliderContainer>
                    </TestBox>
                    {
                    !littleScreen &&
                        <SidebarBox>
                            <SidebarCard>
                                <SidebarTitle><img src="/svg/pc-search-black.svg" width={20} height={20} alt="" />{guideHeaderText}</SidebarTitle>
                                <ChecklistSection />
                                <OptionZenSection />
                            </SidebarCard>
                        </SidebarBox>
                    }
                    {
                        littleScreen &&
                        <div
                            style={{
                                position: "fixed",
                                bottom: 0,
                                left: 0,
                                width: "100%",
                                backgroundColor: "white",
                                transition: "all 0.4s ease",
                                color: "black",
                                zIndex: 100,
                                boxShadow: "0 -2px 10px rgba(0,0,0,0.1)",
                            }}
                        >
                            <div
                                onClick={() => setIsMobileInfoBoxOpen(!isMobileInfoBoxOpen)}
                                style={{
                                    width: "100%",
                                    cursor: "pointer",
                                    padding: "16px 20px 10px",
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    gap: '0.5rem',
                                }}
                            >
                                <img src="/svg/pc-search-black.svg" width={20} height={20} alt="" />
                                <h4>{guideHeaderText}</h4>
                                <span style={{
                                    marginLeft: 'auto',
                                    display: 'flex',
                                    alignItems: 'center',
                                    transform: isMobileInfoBoxOpen ? 'rotate(0deg)' : 'rotate(180deg)',
                                    transition: 'transform 0.3s ease',
                                }}>
                                    <ChevronDown />
                                </span>
                            </div>
                            <div
                                style={{
                                    maxHeight: isMobileInfoBoxOpen ? "70vh" : "0px",
                                    overflow: "auto",
                                    transition: "max-height 0.4s ease",
                                    padding: isMobileInfoBoxOpen ? "0 18px 18px" : "0 18px",
                                }}
                            >
                                <ChecklistSection />
                                <OptionZenSection />
                            </div>
                        </div>
                    }
                </PreviewContainer>
              </MainContainerCenter>
            </MainContainerCol>
          </MainContainerRow>
        </DndProvider>
      </ErrorBoundary>
    </Container>
  );
};

const RendererIframe = styled.iframe<{
    aspectRatio: number;
    $numItems: number;
}>`
    display: block;
    border: none;
    height: min(60vh, calc(100cqw / (${props => props.$numItems} * ${props => props.aspectRatio})));
    width: auto;
    aspect-ratio: ${props => props.aspectRatio};
    flex-shrink: 0;

    @media (max-width: ${styleConstants.breakpointMd}) {
        height: min(40vh, calc(100cqw / (${props => props.$numItems} * ${props => props.aspectRatio})));
    }
`

const IframeContainer = styled.div<{
    aspectRatio: number
}>`
    display: flex;
    flex-shrink: 0;
    align-items: center;
`

const ZoomableContent = styled.div<{ $loading: boolean }>`
    display: flex;
    align-items: center;
    opacity: ${({ $loading }) => $loading ? 0 : 1};
    visibility: ${({ $loading }) => $loading ? 'hidden' : 'visible'};
    transition: opacity 90ms linear;
`

const RendererLoadingOverlay = styled.div<{ $visible: boolean }>`
    position: absolute;
    inset: 0;
    z-index: 5;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg, #f8f8f8 0%, #ffffff 100%);
    opacity: ${({ $visible }) => $visible ? 1 : 0};
    pointer-events: ${({ $visible }) => $visible ? 'all' : 'none'};
    transition: opacity 120ms linear;
`

const PrefetchIframes = styled.div`
    position: absolute;
    width: 1px;
    height: 1px;
    overflow: hidden;
    opacity: 0;
    pointer-events: none;
`

const PrefetchIframe = styled.iframe`
    width: 1px;
    height: 1px;
    border: 0;
    display: block;
`

const LoaderDot = styled.div`
    width: 22px;
    height: 22px;
    border-radius: 50%;
    border: 3px solid #d5d9df;
    border-top-color: #2e7c81;
    animation: spinnerRotate 0.9s linear infinite;

    @keyframes spinnerRotate {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
`

const BlankPage = styled.div<{ aspectRatio: number; $numItems: number }>`
    display: block;
    background: white;
    box-shadow: 0 1px 4px rgba(0,0,0,0.12);
    height: min(60vh, calc(100cqw / (${props => props.$numItems} * ${props => props.aspectRatio})));
    width: auto;
    aspect-ratio: ${props => props.aspectRatio};
    flex-shrink: 0;

    @media (max-width: ${styleConstants.breakpointMd}) {
        height: min(40vh, calc(100cqw / (${props => props.$numItems} * ${props => props.aspectRatio})));
    }
`

const RendererWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding-top: 3rem;
`

const PageNavButton = styled.div<{ side: 'left' | 'right'; $visible: boolean }>`
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: ${({ $visible }) => $visible ? 'pointer' : 'default'};
    z-index: 10;
    visibility: ${({ $visible }) => $visible ? 'visible' : 'hidden'};
    opacity: ${({ $visible }) => $visible ? 1 : 0};
    pointer-events: ${({ $visible }) => $visible ? 'all' : 'none'};
    transition: opacity 120ms ease;

    &:hover {
        background-color: #f5f5f5;
    }

    @media (max-width: ${styleConstants.breakpointMd}) {
        width: 28px;
        height: 28px;
        opacity: ${({ $visible }) => $visible ? 1 : 0};
        pointer-events: ${({ $visible }) => $visible ? 'all' : 'none'};
    }
`

const RendererContainer = styled.div`
    flex: 1;
    min-width: 0;
    margin: 0 10px;
    overflow: hidden;
    display: flex;
    position: relative;
    justify-content: center;
    align-items: center;
    container-type: inline-size;

    @media (max-width: ${styleConstants.breakpointMd}) {
        margin: 0 6px;
    }
`

const SliderContainer = styled.div`
    max-width: 80vw;
    width: 100%;
    margin: 1rem auto;
    height: 25vh;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    @media (max-width: ${styleConstants.breakpointMd}) {
        max-width: 90vw;
        width: 90vw;
        height: 15vh;
        margin: 2rem auto 0 auto;
        padding: 0 36px;
        box-sizing: border-box;
    }
`

const ArrowButtonBase = styled.div<{ $visible: boolean }>`
    cursor: ${({ $visible }) => $visible ? 'pointer' : 'default'};
    z-index: 10;
    padding: 0.5rem;
    display: flex;
    align-items: center;
    visibility: ${({ $visible }) => $visible ? 'visible' : 'hidden'};
    opacity: ${({ $visible }) => $visible ? 1 : 0};
    pointer-events: ${({ $visible }) => $visible ? 'all' : 'none'};
    transition: opacity 120ms ease;

    @media (max-width: ${styleConstants.breakpointMd}) {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        opacity: ${({ $visible }) => $visible ? 1 : 0};
        pointer-events: ${({ $visible }) => $visible ? 'all' : 'none'};
    }
`

const ArrowButtonLeft = styled(ArrowButtonBase)`
    @media (max-width: ${styleConstants.breakpointMd}) {
        left: 0;
    }
`

const ArrowButtonRight = styled(ArrowButtonBase)`
    @media (max-width: ${styleConstants.breakpointMd}) {
        right: 0;
    }
`

const TestBox = styled.div`
`;

const SidebarBox = styled.div`
    width: 390px;
    flex-shrink: 0;
    height: 100%;
    color: black;
`

const SidebarCard = styled.div`
    margin: 1rem;
    margin-top: 1.5rem;
    height: 95%;
    width: 90%;
    border-radius: 10px;
    background-color: white;
    padding: 1rem;
    overflow: hidden;
`

const SidebarTitle = styled.h4`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    margin-bottom: 0.6rem;
    font-size: 14px;
`

const PreviewContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;

  @media (max-width: ${styleConstants.breakpointMd}) {
    flex-direction: column;
  }
`

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  // height: -webkit-fill-available;
`;

const MainContainerRow = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: row;
  position: relative;
  max-width: 100%;
  max-height: calc(100% - 72px); /* 72px is TopBar height */

  @media (max-width: ${styleConstants.breakpointLg}) {
    // max-height: calc(100% - 64px - 48px); /* 64px is TopBar height */
    flex-direction: column;
    flex-grow: 1;
    overflow: hidden;
  }
`;

const MainContainerCol = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  min-width: 0;

  height: 100%;

  @media (max-width: ${styleConstants.breakpointLg}) {
    flex-grow: 1;
    position: relative;
  }
`;

const MainContainerCenter = styled.div`
  display: flex;
  position: relative;
  overflow: hidden;
  flex-grow: 1;
  flex-direction: row;
  max-width: 100%;
  min-height: 0;
  height: calc(100% - 58px); /* 58px is BottomBar height */
  @media (max-width: ${styleConstants.breakpointLg}) {
    flex-grow: 1;
  }
`;

// const Embla = styled.div`
//     // overflow: hidden;
//     width: 85%;
// `;

// const EmblaContainer = styled.div`
//     display: flex;
//     justify-content: center;
// `;

// const EmblaSlide = styled.div`
//     flex: 0 0 11%;

//     @media (max-width: ${styleConstants.breakpointLg}) {
//         flex: 0 0 9%;
//     }
// `;

export default PreviewPage;


